'use client';

import { CachePublicRecord, TolgeeProvider, TolgeeStaticData } from '@tolgee/react';
import { useRouter } from 'next/navigation';
import React, { useEffect, useMemo } from 'react';
import { TolgeeBase } from './shared';

type Props = {
  staticData: TolgeeStaticData | CachePublicRecord[];
  language: string;
  children: React.ReactNode;
};

export const TolgeeNextProvider = ({ language, staticData, children }: Props) => {
  const router = useRouter();

  // 为每个语言创建独立的 tolgee 实例，确保语言切换时立即生效
  const tolgee = useMemo(() => {
    return TolgeeBase().init({
      observerOptions: {
        fullKeyEncode: true,
      },
      language,
    });
  }, [language]);

  useEffect(() => {
    const { unsubscribe } = tolgee.on('permanentChange', () => {
      // refresh page when there is a translation update
      router.refresh();
    });

    return () => unsubscribe();
  }, [router, tolgee]);

  // 当语言变化时，立即更新 tolgee 实例的语言
  useEffect(() => {
    if (tolgee.getLanguage() !== language) {
      tolgee.changeLanguage(language);
    }
  }, [language, tolgee]);

  return (
    <TolgeeProvider tolgee={tolgee} ssr={{ language, staticData }}>
      {children}
    </TolgeeProvider>
  );
};
